import { gql, useQuery } from '@apollo/client';
import { OnlineOrderReportPaymentMethodMetrics } from '@client/graphql/types/graphql';

interface OnlineOrderPaymentMethodMetricsData {
  onlineOrderReport_owner_getPaymentMethodMetrics: OnlineOrderReportPaymentMethodMetrics;
}

interface OnlineOrderPaymentMethodMetricsVars {
  branchId: string;
  dateRange: {
    startDate: string;
    endDate: string;
  };
}

const ONLINE_ORDER_PAYMENT_METHOD_METRICS_QUERY = gql`
  query OnlineOrderReportPaymentMethodMetrics($branchId: ID!, $dateRange: OnlineOrderReportDateRangeInput!) {
    onlineOrderReport_owner_getPaymentMethodMetrics(branchId: $branchId, dateRange: $dateRange) {
      totalOrders
      stripeOrders
      cashOrders
      stripeRate
    }
  }
`;

export default function useOnlineOrderPaymentMethodMetrics(branchId: string, startDate: string, endDate: string) {
  return useQuery<OnlineOrderPaymentMethodMetricsData, OnlineOrderPaymentMethodMetricsVars>(
    ONLINE_ORDER_PAYMENT_METHOD_METRICS_QUERY,
    {
      variables: {
        branchId,
        dateRange: {
          startDate,
          endDate,
        },
      },
      skip: !branchId || !startDate || !endDate,
    },
  );
}
